import React from 'react';

interface InlineShimmerProps {
  active?: boolean;
  className?: string;
}

export const InlineShimmer: React.FC<InlineShimmerProps> = ({ active = true, className = '' }) => {
  if (!active) return null;
  return <div className={`aa-inline-shimmer ${className}`} aria-hidden="true" />;
};
